import { useTranslation } from "react-i18next";

import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";
import { useCallback } from "react";
import { IMarComAutomationMessageProps } from "./models";
import {
  createMarComAutomationMessage,
  getMarComAutomationMessageById,
  updateMarComAutomationMessage,
} from "../../../../../../services/marComAutomationMessages.service";
import { messageSchema, TMessageForm } from "./messagesSchema";
import { MessageFields } from "./MessageFields/MessageFields";

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

const Message = ({
  id,
  marComAutomationRuleId,
  onBackButton,
}: IMarComAutomationMessageProps) => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createMarComAutomationMessage,
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateMarComAutomationMessage,
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getMarComAutomationMessageById,
  );

  const saveHandler = (v: TMessageForm) => {
    const priority = Number(v.priority);
    return save({
      ...v,
      marComAutomationRuleId: marComAutomationRuleId ?? "",
      startDate: v.startDate.toISOString().substring(0, 10),
      endDate: v.endDate.toISOString().substring(0, 10),
      ticketChannelStepId: v.ticketChannelStep?.id,
      ticketChannelId: v.ticketChannel?.id,
      ticketAutomationReceivedRuleId: v.finishedFromStart
        ? v.ticketAutomationReceivedRule?.id
        : null,
      ticketChannelStepWhenNotIdentifiedId: v.finishedFromStart &&
      v.ticketAutomationReceivedRule &&
      v.moveTicketWhenNotIdentified
        ? v.ticketChannelStepWhenNotIdentified?.id
        : null,
      priority: !Number.isNaN(priority) ? priority : undefined,
      isMoveHumanAttendant: v.isMoveHumanAttendant,
      isException: false,
      enable: v.enable,
      name: v.name,
    });
  };

  const updateHandler = (v: TMessageForm, id: string) => {
    const priority = Number(v.priority);
    return update({
      item: {
        id: id,
        ...v,
        marComAutomationRuleId: marComAutomationRuleId ?? "",
        startDate: v.startDate.toISOString().substring(0, 10),
        endDate: v.endDate.toISOString().substring(0, 10),
        ticketChannelStepId: v.ticketChannelStep?.id,
        ticketChannelId: v.ticketChannel?.id,
        ticketAutomationReceivedRuleId: v.finishedFromStart
          ? v.ticketAutomationReceivedRule?.id
          : null,
        ticketChannelStepWhenNotIdentifiedId: v.finishedFromStart &&
      v.ticketAutomationReceivedRule &&
      v.moveTicketWhenNotIdentified
          ? v.ticketChannelStepWhenNotIdentified?.id
          : null,
        priority: !Number.isNaN(priority) ? priority : undefined,
        isMoveHumanAttendant: v.isMoveHumanAttendant,
        isException: false,
        enable: v.enable,
        name: v.name,
      },
      id: id,
    });
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TMessageForm>> => {
      const { data, success } = await get(id);

      if (data) {
        const newData: TMessageForm = {
          ...data,
          id: data.id,
          startDate: new Date(`${data.startDate}T12:00:00Z`),
          endDate: new Date(`${data.endDate}T12:00:00Z`),
          ticketChannelStep: data.ticketChannelStep,
          ticketChannel: data.ticketChannel,
          isMoveHumanAttendant: data.isMoveHumanAttendant,
          enable: data.enable,
          name: data.name,
          priority: data.priority?.toString(),
          finishedFromStart: !!data.ticketChannel,
          ticketAutomationReceivedRule: data.ticketAutomationReceivedRule,
          moveTicketWhenNotIdentified:
            !!data.ticketChannelStepWhenNotIdentified,
          ticketChannelStepWhenNotIdentified:
            data.ticketChannelStepWhenNotIdentified,
          ticketChannelWhenNotIdentified: data.ticketChannelStepWhenNotIdentified
            ? data.ticketChannelStepWhenNotIdentified.ticketChannel
            : null,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get],
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TMessageForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "message")}
      schema={messageSchema}
      subtitle={t(translationPath + "new_message")}
      subtitleWatchField={"name"}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={onBackButton}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      defaultValues={{
        isMoveHumanAttendant: false,
        finishedFromStart: false,
        moveTicketWhenNotIdentified: false,
      }}
      fields={() => <MessageFields />}
    />
  );
};

export default Message;
